import * as httpx from "httpx"
import { CancellablePromise } from "real-cancellable-promise"

import {
	ExportResponse,
	EmailRequest,
	EmailResponse,
	FeedbackItem,
	Category,
} from "brandguard/feedback/brandguard.feedback_pb"

export { ExportResponse, EmailRequest, EmailResponse, FeedbackItem, Category }

export type ExportFormat = "json" | "markdown" | "text"

export function exportFeedback(
	eventType: string,
	eventId: string,
	format: ExportFormat = "json",
	...options: httpx.option[]
): CancellablePromise<ExportResponse> {
	return httpx.get<ExportResponse>(
		`${httpx.urlstorage.host()}/bg/feedback/${eventType}/${eventId}`,
		{ format },
		...options,
	)
}

export function sendEmail(
	eventType: string,
	eventId: string,
	req: Omit<EmailRequest, "event_id" | "event_type">,
	...options: httpx.option[]
): CancellablePromise<EmailResponse> {
	return httpx.post<EmailResponse>(
		`${httpx.urlstorage.host()}/bg/feedback/${eventType}/${eventId}/email`,
		{ ...req, event_id: eventId, event_type: eventType },
		...options,
	)
}
